import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { FilterMatchMode } from 'primereact/api';
import { Dialog } from 'primereact/dialog';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import GenerateIdCardDialog from './GenerateIdCard';
import { MultiSelect } from 'primereact/multiselect';
import { SelectButton } from 'primereact/selectbutton';
import { useCatchResponse } from '../../../utils/useCatchResponse';

const IdCardMaster = () => {
    const { catchResponse } = useCatchResponse();
    const [classList, setClassList] = useState([]);
    const [selectedStudents, setSelectedStudents] = useState([]);
    const [studentsList, setStudentsList] = useState([]);
    const [masterData, setMasterData] = useState([]);
    const [classId, setClassId] = useState([]);
    const [cardType, setCardType] = useState('Student');
    const cardTypeOptions = [
        { label: 'Student', value: 'Student' },
        { label: 'Staff', value: 'Staff' },
    ];
    const [staffList, setStaffList] = useState([]);
    const [staffId, setStaffId] = useState([]);
    const [visible, setVisible] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        Name: { value: null, matchMode: FilterMatchMode.CONTAINS },
        board: { value: null, matchMode: FilterMatchMode.CONTAINS },
        medium: { value: null, matchMode: FilterMatchMode.CONTAINS },
        sections: { value: null, matchMode: FilterMatchMode.EQUALS },
        students: { value: null, matchMode: FilterMatchMode.EQUALS },
        totalCapacity: { value: null, matchMode: FilterMatchMode.EQUALS }
    });
    const [selectedYear, setSelectedYear] = useState('');
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [securityUserID, setSecurityUserID] = useState("");
    const [rows, setRows] = useState(10);
    const [first, setFirst] = useState(0);

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        getFinancialYearData(loginData?._id);
        GetStaffList(loginData?._id);
    }, []);

    const GetStaffList = async (id) => {
        try {
            const response = await api.post(APIConstant.path.getStaffPickList, { SchoolId: id });
            if (response.success) {
                setStaffList((response?.data || []).map(x => ({
                    ...x,
                    id: x?._id,
                    value: x?._id,
                    label: x?.Name,
                    Name: x?.Name,
                    Designation: x?.Designation || '',
                    Email: x?.Email || '',
                    Phone: x?.Phone || '',
                })));
            }
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    };

    const onChangeCardType = (val) => {
        if (!val) return;
        setCardType(val);
        setClassId([]);
        setStaffId([]);
        setStudentsList([]);
        setSelectedStudents([]);
    };

    const onChangeStaff = (e) => {
        const ids = e.value;
        setStaffId(ids);
        const rows = staffList.filter(s => ids.includes(s.value));
        setStudentsList(rows);
        setSelectedStudents(rows);
    };


    const getFinancialYearData = async (id) => {
        const years = await CommonConfig.getFinancialYears(id);
        const currentYear = CommonConfig.getCurrentFinancialYear(years);
        const selectedAcYear = CommonConfig.getCookie('selectedAcademicYear');
        setSelectedYear(selectedAcYear ?? currentYear?.value);
        await GetClassList(id, selectedAcYear ?? currentYear?.value);
    }

    const onPageChange = (e) => {
        setFirst(e.first);
        setRows(e.rows);
    };

    const GetClassList = async (id, academicYearId) => {
        try {
            let data = {
                UserID: id,
                FinancialYearId: academicYearId
            }
            await api.post(APIConstant.path.getClassList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setClassList(res?.data?.filter(x => x?.Status === 'Active')?.map(x => ({
                        ...x,
                        label: `${x?.ClassName}-${x?.SectionFullName}-${x?.MediumName}-${x?.Board}`,
                        value: x?._id
                    })));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const onCancel = () => {
        setVisible(false);
    }

    const onChangeClass = async (e) => {
        const selectedClassIds = e.value;
        setClassId(selectedClassIds);

        let updatedStudentsList = [];

        const results = await Promise.all(
            selectedClassIds.map(async (classId) => {
                const classData = await GetClassStudentsList(classId);
                return classData || [];
            })
        );
        updatedStudentsList = results.flat();

        setStudentsList(updatedStudentsList);
        setSelectedStudents(updatedStudentsList);
    };

    const GetClassStudentsList = async (id) => {
        try {
            const response = await api.post(APIConstant.path.GetClassConfigStudentDetail, {
                ClassId: id, FinancialYearId: selectedYear,
                UserID: securityUserID,
            });
            if (response.success) {
                return response?.data?.sort((a, b) => a?.RollNo - b?.RollNo);
            } else {
                return [];
            }
        } catch (err) {
            console.log(err);
            catchResponse(err);
            return [];
        }
    };

    const actionBodyTemplateSrNo = (data, props) => {
        return props.rowIndex + 1;
    };

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    return (
        <div className='wayment-owner-dashboard et-master-page'>
            <style>{`
                .id-tab-select.p-selectbutton { display:flex; gap:0.5rem; }
                .id-tab-select.p-selectbutton .p-button { 
                    border-radius: 6px !important;
                    border: none !important;
                    background-color: rgba(0, 0, 0, 0.05) !important;
                    padding: 0.25rem 0.75rem !important;
                    height: 2rem !important;
                    color: #0f0f0f !important;
                    font-size: 0.875rem !important;
                    font-weight: 600 !important;
                    transition: min-width 0.5s ease;
                    box-shadow: none !important;
                }
                .id-tab-select.p-selectbutton .p-button:hover,
                .id-tab-select.p-selectbutton .p-button.p-highlight {
                    background-color: #4e8ba5 !important;
                    color: #FFFFFF !important;
                }
                .id-tab-select.p-selectbutton .p-button .p-button-label {
                    font-weight: inherit !important;
                    color: inherit !important;
                }
            `}</style>
            <div className="heading-area p-d-flex p-ai-center p-jc-between">
                <div className="p-d-flex p-ai-baseline">
                    <i className="pi pi-id-card"></i>
                    <h2>ID Card Generator</h2>
                </div>
                <div className="p-d-flex p-ai-center">
                    <SelectButton 
                        value={cardType} 
                        options={cardTypeOptions} 
                        className="id-tab-select p-mr-2"
                        onChange={(e) => { if (e.value) { onChangeCardType(e.value); } }} 
                    />
                    <div className="searchbar-area e-searchbar-area p-mr-0">
                        <i className="pi pi-search" />
                        <InputText
                            value={globalFilterValue}
                            onChange={onGlobalFilterChange}
                            placeholder="Global Search"
                        />
                    </div>
                    {cardType === 'Student' ? (
                        <div className="searchbar-area class-search id-g-badge-parent">
                            <MultiSelect id="className" className='id-g-badge-child'
                                value={classId} options={classList} onChange={(e) => onChangeClass(e)} placeholder="Please Select Class"
                                display="chip"
                                filter />
                        </div>
                    ) : (
                        <div className="searchbar-area class-search id-g-badge-parent">
                            <MultiSelect id="staffName" className='id-g-badge-child'
                                value={staffId} options={staffList} onChange={(e) => onChangeStaff(e)} placeholder="Please Select Staff"
                                display="chip"
                                filter />
                        </div>
                    )}
                    {(cardType === 'Student' ? classId.length : staffId.length) ?
                        <Button icon="pi pi-plus" className="e-h-btn" onClick={() => setVisible(true)} />
                        : null}
                </div>
            </div>
            <DataTable
                value={studentsList}
                paginator
                rows={rows}
                first={first}
                filters={filters}
                filterDisplay="menu"
                globalFilterFields={['Name', 'Email', 'Phone', 'ClassName', 'RollNo']}
                responsiveLayout="scroll"
                paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink JumpToPageInput"
                rowsPerPageOptions={[5, 10, 20]}
                currentPageReportTemplate="Showing {first}-{last} of {totalRecords} records"
                onPage={onPageChange}
                selectionMode="checkbox" selection={selectedStudents}
                onSelectionChange={(e) => setSelectedStudents(e.value)}
                className='custom-table'
                scrollHeight='calc(100vh - 120px)'
                size='small'
            >
                <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                <Column field="id" body={actionBodyTemplateSrNo} header="Sr No." />
                <Column
                    field="Name"
                    header={cardType === 'Staff' ? 'Staff Name' : 'Student Name'}
                />
                {cardType === 'Staff' ? (
                    <Column field="Designation" header="Designation" />
                ) : (
                    <Column field="ClassName" header="Class Name" />
                )}
                {cardType === 'Student' && (
                    <Column field="RollNo" header="Roll No." />
                )}
                <Column
                    field="Email"
                    header="Email"
                />
                <Column
                    field="Phone"
                    header="Phone"
                />
            </DataTable>

            <Dialog
                header='Generate Id Card'
                className='dialog-popup'
                visible={visible}
                onHide={() => onCancel()}
                draggable={false}
                position="center"
            >
                <GenerateIdCardDialog masterData={masterData} isEdit={isEdit} ID={classId} onCancel={onCancel} studentsData={selectedStudents} isStaff={cardType === 'Staff'} />

            </Dialog>
        </div>
    );
};

export default IdCardMaster;
